module.exports = __webpack_public_path__ + "static/elanco-f75135a1396066f2f91a86e5377fab93.png";